import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";


export default React.createClass({
  displayName: "standard-server-and-dashboard",
  getInitialState: function() {
    return {
      scrollToElement: scrollToElement
    };
    var scrollToElement = initDeepLinkData(this.props);
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container server_integration">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="1-n-search">1:N Search</h2>
                </div>
                <p>This guide provides an in-depth look at 1:N Search in the FaceTec SDKs.</p>
                <hr/>
              </section>

              <iframe src="https://docs.google.com/document/d/1u3GHHKQXNrQyYN89Bi6nGQuyhHPjhWX0ov1y0phLcmg/preview" width="100%" height="100%"></iframe>

              <SDKSidebar menuType="main" title="Standard Server and Dashboard"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/1-to-n-search.jsx